import type { LoadingArea } from "@/stores/useLoadingStore"

const useLoading = (target?: LoadingArea) => {
  const loadingStore = useLoadingStore()
  const { load, unload, reset } = loadingStore

  const count = ref(0)

  const isLoading = computed(() => {
    if (target === undefined) return count.value !== 0

    return !!(loadingStore.mapCount.get(target) || 0)
  })

  const handleLoad = () => {
    if (target === undefined) {
      count.value += 1
      return
    }

    load(target)
  }
  const handleUnload = () => {
    if (target === undefined) {
      count.value -= 1
      return
    }

    unload(target)
  }

  const handleReset = () => {
    if (target === undefined) {
      count.value = 0
      return
    }

    reset(target)
  }

  return {
    isLoading,
    load: handleLoad,
    unload: handleUnload,
    reset: handleReset
  }
}

export default useLoading
